import "./chunk--chunk-RQ7252KT.js";

// src/js/components/ShopifySubscriptionsWidget.js
var ShopifySubscriptionsWidget = class {
  constructor(el) {
    this.el = el;
    this.select = el.querySelector("[data-subscriptions-select]");
    this.input = el.querySelector("input");
    this.selectLabel = el.querySelector("[data-subscriptions-select-label]");
    this.optionContainer = el.querySelector("[data-subscriptions-option-container]");
    this.sellingPlanOptions = el.querySelectorAll("[data-subscriptions-option]");
    this.subscriptionInputs = el.querySelectorAll("[data-subscription-input]");
    this.atcInput = el.querySelector("[data-atc-input]");
  }
  init() {
    this.initShopifySubscriptions();
  }
  initShopifySubscriptions() {
    this.subscriptionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        if (!this.atcInput.value && input.value == "subscription") {
          this.atcInput.value = this.select.getAttribute("data-value");
        } else if (input.value == "one-time") {
          this.atcInput.value = null;
        }
      });
    });
    this.select.addEventListener("click", () => {
      this.optionContainer.classList.remove("hidden");
      this.optionContainer.classList.add("block");
    });
    if (this.sellingPlanOptions) {
      this.sellingPlanOptions.forEach((option) => {
        option.addEventListener("click", () => {
          this.atcInput.value = option.getAttribute("data-value");
          this.select.setAttribute("data-value", option.getAttribute("data-value"));
          this.selectLabel.innerHTML = option.innerHTML;
          this.optionContainer.classList.remove("block");
          this.optionContainer.classList.add("hidden");
        });
      });
    }
    const focusObserveEl = this.el.closest(".group");
    if (focusObserveEl) {
      focusObserveEl.addEventListener("mouseleave", () => {
        this.optionContainer.classList.remove("block");
        this.optionContainer.classList.add("hidden");
      });
    }
  }
};
var ShopifySubscriptionsWidget_default = ShopifySubscriptionsWidget;
export {
  ShopifySubscriptionsWidget_default as default
};
